var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.005,
    viewBox: "0 0 24 24.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5289",
    "data-name": "Caminho 5289",
    d: "M11.839,22.679a10.758,10.758,0,0,0,6.893-2.474L23.224,24.7A1.043,1.043,0,1,0,24.7,23.223l-4.5-4.5a10.837,10.837,0,1,0-8.365,3.95ZM5.649,5.651a8.752,8.752,0,1,1,0,12.377A8.7,8.7,0,0,1,5.649,5.651Z",
    transform: "translate(-1.005 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5290",
    "data-name": "Caminho 5290",
    d: "M7.612,15.469a1,1,0,0,0,.707-1.707,3.21,3.21,0,0,1,0-4.533A1,1,0,0,0,6.905,7.815a5.212,5.212,0,0,0,0,7.361A1,1,0,0,0,7.612,15.469Z",
    transform: "translate(-0.782 -0.565)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3109bee241fdd2fb216ebc79d03a28fa.svg";
export { ForwardRef as ReactComponent };